import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { gridCellClass } from "./TireComparisonGrid";
import { selectComparePricing } from "./selectComparePricing";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
};

export const hasPropmotions = (visibleResults?: CompareResults[]): boolean => {
  const result =
    visibleResults?.some(({ part }) => {
      const { promotionPricingText, promotionText } = selectComparePricing(
        part.partPricing.primaryPart.price
      );
      return promotionPricingText?.["en"] || promotionText?.["en"];
    }) ?? false;
  return result;
};

export const Promotion: FunctionComponent<ProductInfoProps> = ({ part }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const { promotionPricingText, promotionText } = selectComparePricing(
    part.partPricing.primaryPart.price
  );
  const text = promotionPricingText?.[language] || promotionText?.[language];
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) && text ? (
        <>{text}</>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
